import { CommonModule, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { KuiModule } from "app/key-ui";
import { KeyDateRangeSelectComponent } from "./date-range-selection.component";
import { KeyDateSelectComponent } from "./date-selection.component";
import { KuiDateRangeNewComponent } from "app/key-ui/daterange/daterange-new/daterange-new.component";

const COMPONENTS = [
    KeyDateSelectComponent,
    KeyDateRangeSelectComponent
];

@NgModule({
    imports: [
        KuiModule,
        CommonModule,
        TranslateModule,
        KuiDateRangeNewComponent
    ],
    exports: COMPONENTS,
    declarations: COMPONENTS,
    providers: [
        DatePipe,
    ],
})
export class KeyDatesModule { }
